module.exports = __webpack_public_path__ + "img/rocking-chairs-04.5092f6cd.jpeg";